import { replace, isNullOrWhiteSpace } from "../fable_modules/fable-library-js.4.24.0/String.js";
import { defaultArg, some } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { Union } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { getUnionCases, makeUnion, name, union_type } from "../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { tryPick } from "../fable_modules/fable-library-js.4.24.0/Array.js";
import { FSharpResult$2 } from "../fable_modules/fable-library-js.4.24.0/Result.js";
import { compare, today as today_1 } from "../fable_modules/fable-library-js.4.24.0/Date.js";

export function tryStr(str) {
    if (!isNullOrWhiteSpace(str)) {
        return str;
    }
    else {
        return undefined;
    }
}

export function tryNull(x) {
    if (x == null) {
        return undefined;
    }
    else {
        return some(x);
    }
}

/**
 * Expects a base64 encoded string
 */
export function UrlSafeB64_encode(s) {
    return replace(replace(replace(s, "+", "."), "/", "_"), "=", "-");
}

/**
 * Expects a base64 |> UrlSafeB64.encode encoded string
 */
export function UrlSafeB64_decode(s) {
    return replace(replace(replace(s, ".", "+"), "_", "/"), "-", "=");
}

export class Role extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Booking", "CustomerService", "Controller", "Operator", "EmployeeSea", "EmployeeLand", "CompanyAdmin"];
    }
    toString() {
        const this$ = this;
        return (this$.tag === 1) ? "Kundeservice" : ((this$.tag === 2) ? "Kontrollør" : ((this$.tag === 3) ? "Driftspersonell" : ((this$.tag === 4) ? "Ansatt sjø" : ((this$.tag === 5) ? "Ansatt land" : ((this$.tag === 6) ? "Admin" : "Bookingansvarlig")))));
    }
}

export function Role_$reflection() {
    return union_type("Shared.Role", [], Role, () => [[], [], [], [], [], [], []]);
}

export function Role__get_Identifier(this$) {
    switch (this$.tag) {
        case 1:
            return 2;
        case 2:
            return 3;
        case 3:
            return 4;
        case 4:
            return 5;
        case 5:
            return 6;
        case 6:
            return 7;
        default:
            return 1;
    }
}

export function Role_FromId_Z524259A4(x) {
    switch (x) {
        case 1:
            return new Role(0, []);
        case 2:
            return new Role(1, []);
        case 3:
            return new Role(2, []);
        case 4:
            return new Role(3, []);
        case 5:
            return new Role(4, []);
        case 6:
            return new Role(5, []);
        case 7:
            return new Role(6, []);
        default:
            return undefined;
    }
}

export function Role_All() {
    return [new Role(0, []), new Role(1, []), new Role(2, []), new Role(3, []), new Role(4, []), new Role(5, []), new Role(6, [])];
}

export class CrewCertificateTier extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["CaptainAndMates", "Engineers", "Any"];
    }
    toString() {
        const this$ = this;
        return (this$.tag === 1) ? "Maskinister" : ((this$.tag === 2) ? "Alle" : "Kaptein og styrmenn");
    }
}

export function CrewCertificateTier_$reflection() {
    return union_type("Shared.CrewCertificateTier", [], CrewCertificateTier, () => [[], [], []]);
}

export function CrewCertificateTier__get_Identifier(this$) {
    switch (this$.tag) {
        case 1:
            return 2;
        case 2:
            return 3;
        default:
            return 1;
    }
}

export function CrewCertificateTier_FromId_Z524259A4(x) {
    switch (x) {
        case 2:
            return new CrewCertificateTier(1, []);
        case 3:
            return new CrewCertificateTier(2, []);
        default:
            return new CrewCertificateTier(0, []);
    }
}

export class VesselRoute extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Main", "Reserved", "Backup"];
    }
    toString() {
        const this$ = this;
        return (this$.tag === 1) ? "Reservert" : ((this$.tag === 2) ? "Reserve" : "Hoved");
    }
}

export function VesselRoute_$reflection() {
    return union_type("Shared.VesselRoute", [], VesselRoute, () => [[], [], []]);
}

export function VesselRoute_FromId_Z524259A4(x) {
    switch (x) {
        case 2:
            return new VesselRoute(1, []);
        case 3:
            return new VesselRoute(2, []);
        default:
            return new VesselRoute(0, []);
    }
}

export function VesselRoute__get_Id(this$) {
    switch (this$.tag) {
        case 1:
            return 2;
        case 2:
            return 3;
        default:
            return 1;
    }
}

export class Vessel_Type extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Speedboat", "Ferry"];
    }
    toString() {
        const this$ = this;
        return (this$.tag === 1) ? "Ferge" : "Hurtigbåt";
    }
}

export function Vessel_Type_$reflection() {
    return union_type("Shared.Vessel.Type", [], Vessel_Type, () => [[], []]);
}

export function Vessel_Type__get_Id(this$) {
    if (this$.tag === 1) {
        return 1;
    }
    else {
        return 0;
    }
}

export function Vessel_Type_FromString_Z721C83C5(str) {
    switch (str) {
        case "Hurtigbåt":
            return new Vessel_Type(0, []);
        case "Ferge":
            return new Vessel_Type(1, []);
        default:
            return new Vessel_Type(1, []);
    }
}

export function Vessel_Type_TryFromString_Z721C83C5(str) {
    switch (str) {
        case "Hurtigbåt":
            return new Vessel_Type(0, []);
        case "Ferge":
            return new Vessel_Type(1, []);
        default:
            return undefined;
    }
}

export function Vessel_Type_FromId_Z524259A4(id) {
    switch (id) {
        case 0:
            return new Vessel_Type(0, []);
        case 1:
            return new Vessel_Type(1, []);
        default:
            return new Vessel_Type(0, []);
    }
}

export function Vessel_Type_TryFromId_Z524259A4(id) {
    switch (id) {
        case 0:
            return new Vessel_Type(0, []);
        case 1:
            return new Vessel_Type(1, []);
        default:
            return undefined;
    }
}

export function Vessel_Type_get_All() {
    return [new Vessel_Type(0, []), new Vessel_Type(1, [])];
}

export class Vessel_Cert extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Passenger", "Security"];
    }
    toString() {
        const this$ = this;
        return (this$.tag === 1) ? "Sikkerhetssertifikat" : "Passasjersertifikat";
    }
}

export function Vessel_Cert_$reflection() {
    return union_type("Shared.Vessel.Cert", [], Vessel_Cert, () => [[], []]);
}

/**
 * Value string
 */
export function Vessel_Cert__get_Id(this$) {
    if (this$.tag === 1) {
        return "security";
    }
    else {
        return "passenger";
    }
}

/**
 * NOTE: Defaults to "Passenger". Use TryFromId if you're unsure "str" is a legit value.
 */
export function Vessel_Cert_FromId_Z721C83C5(str) {
    switch (str) {
        case "passenger":
            return new Vessel_Cert(0, []);
        case "security":
            return new Vessel_Cert(1, []);
        default:
            return new Vessel_Cert(0, []);
    }
}

export function Vessel_Cert_TryFromId_Z721C83C5(str) {
    switch (str) {
        case "passenger":
            return new Vessel_Cert(0, []);
        case "security":
            return new Vessel_Cert(1, []);
        default:
            return undefined;
    }
}

export function Vessel_Cert_get_All() {
    return [new Vessel_Cert(0, []), new Vessel_Cert(1, [])];
}

/**
 * Prints the cert together with the vessel type
 */
export function Vessel_certWithTypePrint(vesselType, cert) {
    const typeStr = (vesselType.tag === 1) ? "passasjerskip" : "hurtigbåt";
    if (cert.tag === 1) {
        return `Sikkerhetssertifikat for ${typeStr}`;
    }
    else {
        return "Passasjersertifikat";
    }
}

export class Vessel_FerryEuClass extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["B", "C", "D"];
    }
    toString() {
        const this$ = this;
        return (this$.tag === 1) ? "EU-C" : ((this$.tag === 2) ? "EU-D" : "EU-B");
    }
}

export function Vessel_FerryEuClass_$reflection() {
    return union_type("Shared.Vessel.FerryEuClass", [], Vessel_FerryEuClass, () => [[], [], []]);
}

export function Vessel_FerryEuClass__get_Id(this$) {
    switch (this$.tag) {
        case 1:
            return "eu-c";
        case 2:
            return "eu-d";
        default:
            return "eu-b";
    }
}

/**
 * NOTE: Defaults to B. Use TryFromId if you're unsure "str" is a legit value.
 */
export function Vessel_FerryEuClass_FromId_Z721C83C5(str) {
    switch (str) {
        case "eu-b":
            return new Vessel_FerryEuClass(0, []);
        case "eu-c":
            return new Vessel_FerryEuClass(1, []);
        case "eu-d":
            return new Vessel_FerryEuClass(2, []);
        default:
            return new Vessel_FerryEuClass(0, []);
    }
}

export function Vessel_FerryEuClass_TryFromId_Z721C83C5(str) {
    switch (str) {
        case "eu-b":
            return new Vessel_FerryEuClass(0, []);
        case "eu-c":
            return new Vessel_FerryEuClass(1, []);
        case "eu-d":
            return new Vessel_FerryEuClass(2, []);
        default:
            return undefined;
    }
}

export function Vessel_FerryEuClass_get_All() {
    return [new Vessel_FerryEuClass(0, []), new Vessel_FerryEuClass(1, []), new Vessel_FerryEuClass(2, [])];
}

export class Vessel_NavigationArea extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["FO1", "FO2", "FO3", "FO4", "SmallCoastArea"];
    }
    toString() {
        const this$ = this;
        return (this$.tag === 1) ? "FO2" : ((this$.tag === 2) ? "FO3" : ((this$.tag === 3) ? "FO4" : ((this$.tag === 4) ? "Liten kystfart" : "FO1")));
    }
}

export function Vessel_NavigationArea_$reflection() {
    return union_type("Shared.Vessel.NavigationArea", [], Vessel_NavigationArea, () => [[], [], [], [], []]);
}

export function Vessel_NavigationArea__get_Id(this$) {
    switch (this$.tag) {
        case 1:
            return "fo2";
        case 2:
            return "fo3";
        case 3:
            return "fo4";
        case 4:
            return "small_coast_area";
        default:
            return "fo1";
    }
}

export function Vessel_NavigationArea_FromId_Z721C83C5(str) {
    switch (str) {
        case "fo1":
            return new Vessel_NavigationArea(0, []);
        case "fo2":
            return new Vessel_NavigationArea(1, []);
        case "fo3":
            return new Vessel_NavigationArea(2, []);
        case "fo4":
            return new Vessel_NavigationArea(3, []);
        case "small_coast_area":
            return new Vessel_NavigationArea(4, []);
        default:
            return new Vessel_NavigationArea(0, []);
    }
}

export function Vessel_NavigationArea_TryFromId_Z721C83C5(str) {
    switch (str) {
        case "fo1":
            return new Vessel_NavigationArea(0, []);
        case "fo2":
            return new Vessel_NavigationArea(1, []);
        case "fo3":
            return new Vessel_NavigationArea(2, []);
        case "fo4":
            return new Vessel_NavigationArea(3, []);
        case "small_coast_area":
            return new Vessel_NavigationArea(4, []);
        default:
            return undefined;
    }
}

export function Vessel_NavigationArea_get_All() {
    return [new Vessel_NavigationArea(0, []), new Vessel_NavigationArea(1, []), new Vessel_NavigationArea(2, []), new Vessel_NavigationArea(3, []), new Vessel_NavigationArea(4, [])];
}

export class Vessel_VesselState extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Operational", "StandBy", "ColdStandBy", "Shipyard", "Interrupted", "PreviouslyRented", "ForSale", "Sold"];
    }
    toString() {
        const this$ = this;
        return (this$.tag === 1) ? "Opplag" : ((this$.tag === 2) ? "Kaldt opplag" : ((this$.tag === 3) ? "Verksted" : ((this$.tag === 4) ? "Driftsavbrudd" : ((this$.tag === 5) ? "Tidligere innleid" : ((this$.tag === 6) ? "For salg" : ((this$.tag === 7) ? "Solgt" : "I drift"))))));
    }
}

export function Vessel_VesselState_$reflection() {
    return union_type("Shared.Vessel.VesselState", [], Vessel_VesselState, () => [[], [], [], [], [], [], [], []]);
}

/**
 * Maps vesselstate to int.
 */
export function Vessel_VesselState__get_Identifier(this$) {
    switch (this$.tag) {
        case 1:
            return 2;
        case 2:
            return 3;
        case 3:
            return 4;
        case 4:
            return 5;
        case 5:
            return 6;
        case 6:
            return 7;
        case 7:
            return 8;
        default:
            return 1;
    }
}

/**
 * Tries to get vessel state from identifier int, returns None if identifier is invalid.
 */
export function Vessel_VesselState_TryFromIdentifier_Z524259A4(i) {
    switch (i) {
        case 1:
            return new Vessel_VesselState(0, []);
        case 2:
            return new Vessel_VesselState(1, []);
        case 3:
            return new Vessel_VesselState(2, []);
        case 4:
            return new Vessel_VesselState(3, []);
        case 5:
            return new Vessel_VesselState(4, []);
        case 6:
            return new Vessel_VesselState(5, []);
        case 7:
            return new Vessel_VesselState(6, []);
        case 8:
            return new Vessel_VesselState(7, []);
        default:
            return undefined;
    }
}

/**
 * Get vesselstate from identifier int, defaults to Operation if identifier is invalid.
 */
export function Vessel_VesselState_get_FromIdentifier() {
    return (arg) => defaultArg(Vessel_VesselState_TryFromIdentifier_Z524259A4(arg), new Vessel_VesselState(0, []));
}

export const Vessel_allVesselStates = [new Vessel_VesselState(0, []), new Vessel_VesselState(1, []), new Vessel_VesselState(2, []), new Vessel_VesselState(3, []), new Vessel_VesselState(4, []), new Vessel_VesselState(5, []), new Vessel_VesselState(6, []), new Vessel_VesselState(7, [])];

export class Vessel_LandPowerConnector extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Round", "Flat"];
    }
    toString() {
        const this$ = this;
        return (this$.tag === 1) ? "Flatstikk" : "Rundstikk";
    }
}

export function Vessel_LandPowerConnector_$reflection() {
    return union_type("Shared.Vessel.LandPowerConnector", [], Vessel_LandPowerConnector, () => [[], []]);
}

export function Vessel_LandPowerConnector_All() {
    return [new Vessel_LandPowerConnector(0, []), new Vessel_LandPowerConnector(1, [])];
}

export function Vessel_LandPowerConnector_FromId_Z524259A4(x) {
    if (x === 2) {
        return new Vessel_LandPowerConnector(1, []);
    }
    else {
        return new Vessel_LandPowerConnector(0, []);
    }
}

export function Vessel_LandPowerConnector__get_Identifier(this$) {
    if (this$.tag === 1) {
        return 2;
    }
    else {
        return 1;
    }
}

export class Vessel_Audit_Prop extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Uuid", "CompanyId", "IMONumber", "MMSINumber", "Name", "CallSign", "Status", "VesselTypeId", "VesselSubTypeId", "ConstructionDate", "KeelStretchDate", "HomePort", "MainRouteId", "ReservedRouteId", "BackupRouteId", "TechnicalInspectorId", "PrimaryPropulsionEffect", "SecondaryPropulsionEffect", "GrossTons", "NetTons", "SecurityTonnage", "DeadWeight", "LengthOverall", "WidthOverall", "WaterLineMaxHeight", "WaterLineMaxDraft", "PropulsionEffect", "NoXFactorMGO", "NoXFactorLNG", "MaxClearanceHeight", "SuspendedDeck", "LowerDeck", "CruisingSpeed", "MaximumSpeed", "MaximumDeckLoad", "MaximumAxleLoad", "BatteryAge", "BatteryEffect", "BatteryProvider", "BatteryType", "BatteryChargingSystem", "MesTypeId", "MobBoatTypeId", "EngineProvider", "Department", "RouteType", "ElectricalPanelType", "ElectricalPanelProvider", "AutomationSystem", "MesCapacityFleet", "MesCapacityTotal", "NumPassengers", "NumPassengerSeats", "CapacityEuroPallets", "PBE", "PBEOfVTE", "VTE", "MVTE", "PhoneOne", "PhoneTwo", "PhoneCatering", "PhoneSecret", "PhoneMachine", "Email", "Cafeteria", "SelfServiceMachine", "SaloonAboveWaterline", "NumCompartments", "HandicapToilet", "Elevator", "StairElevator", "Wifi", "Playroom", "SickBay", "RequireECDIS", "RequireGMDSS", "RequireHMOB", "RequireEmission", "WaterLineToRecess", "AmpLandPower", "VoltLandPower", "ConnectorTypeId", "PrimaryPropulsionType", "SecondaryPropulsionType", "CaptainCertificate", "ChiefEngineerCertificate", "ChiefMateCertificate", "FirstEngineerCertificate", "FirstMateCertificate", "SecondEngineerCertificate", "NavigationArea", "FreeText"];
    }
}

export function Vessel_Audit_Prop_$reflection() {
    return union_type("Shared.Vessel.Audit.Prop", [], Vessel_Audit_Prop, () => [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []]);
}

export function Vessel_Audit_Prop_FromString_Z721C83C5(str) {
    const option_1 = tryPick((case$) => {
        if (name(case$) === str) {
            return makeUnion(case$, []);
        }
        else {
            return undefined;
        }
    }, getUnionCases(Vessel_Audit_Prop_$reflection()));
    if (option_1 == null) {
        return new FSharpResult$2(1, [`Vessel field ${str} does not exist`]);
    }
    else {
        return new FSharpResult$2(0, [option_1]);
    }
}

export function Vessel_Audit_Prop_ToColumnId_Z1D040058(prop) {
    switch (prop.tag) {
        case 1:
            return 2;
        case 2:
            return 3;
        case 3:
            return 4;
        case 4:
            return 5;
        case 5:
            return 6;
        case 6:
            return 7;
        case 7:
            return 8;
        case 8:
            return 9;
        case 9:
            return 10;
        case 10:
            return 11;
        case 11:
            return 12;
        case 12:
            return 13;
        case 13:
            return 14;
        case 14:
            return 15;
        case 15:
            return 16;
        case 16:
            return 17;
        case 17:
            return 18;
        case 18:
            return 19;
        case 19:
            return 20;
        case 20:
            return 21;
        case 21:
            return 22;
        case 22:
            return 23;
        case 23:
            return 24;
        case 24:
            return 25;
        case 25:
            return 26;
        case 26:
            return 27;
        case 27:
            return 28;
        case 28:
            return 29;
        case 29:
            return 30;
        case 30:
            return 31;
        case 31:
            return 32;
        case 32:
            return 33;
        case 33:
            return 34;
        case 34:
            return 35;
        case 35:
            return 36;
        case 36:
            return 37;
        case 37:
            return 38;
        case 38:
            return 39;
        case 39:
            return 40;
        case 40:
            return 41;
        case 41:
            return 42;
        case 42:
            return 43;
        case 43:
            return 44;
        case 44:
            return 45;
        case 45:
            return 46;
        case 46:
            return 47;
        case 47:
            return 48;
        case 48:
            return 49;
        case 49:
            return 50;
        case 50:
            return 51;
        case 51:
            return 52;
        case 52:
            return 53;
        case 54:
            return 54;
        case 55:
            return 55;
        case 56:
            return 56;
        case 57:
            return 57;
        case 58:
            return 58;
        case 59:
            return 59;
        case 60:
            return 60;
        case 61:
            return 61;
        case 63:
            return 62;
        case 64:
            return 63;
        case 65:
            return 64;
        case 66:
            return 65;
        case 67:
            return 66;
        case 68:
            return 67;
        case 69:
            return 68;
        case 70:
            return 69;
        case 74:
            return 70;
        case 75:
            return 71;
        case 76:
            return 72;
        case 77:
            return 73;
        case 71:
            return 74;
        case 72:
            return 75;
        case 78:
            return 76;
        case 79:
            return 77;
        case 80:
            return 78;
        case 82:
            return 79;
        case 83:
            return 80;
        case 53:
            return 81;
        case 73:
            return 82;
        case 81:
            return 83;
        case 84:
            return 84;
        case 85:
            return 85;
        case 86:
            return 86;
        case 87:
            return 87;
        case 88:
            return 88;
        case 89:
            return 89;
        case 90:
            return 90;
        case 91:
            return 91;
        case 62:
            return 92;
        default:
            return 1;
    }
}

export function Vessel_Audit_Prop_FromColumnId_Z524259A4(column) {
    switch (column) {
        case 1:
            return new FSharpResult$2(0, ["Uuid"]);
        case 2:
            return new FSharpResult$2(0, ["selskap"]);
        case 3:
            return new FSharpResult$2(0, ["IMO-Nummer"]);
        case 4:
            return new FSharpResult$2(0, ["MMSI-Nummer"]);
        case 5:
            return new FSharpResult$2(0, ["navn"]);
        case 6:
            return new FSharpResult$2(0, ["kallsignal"]);
        case 7:
            return new FSharpResult$2(0, ["status"]);
        case 8:
            return new FSharpResult$2(0, ["fartøystype"]);
        case 9:
            return new FSharpResult$2(0, ["fartøyssubtype"]);
        case 10:
            return new FSharpResult$2(0, ["konstruksjonsår"]);
        case 11:
            return new FSharpResult$2(0, ["kjølstrekkelse"]);
        case 12:
            return new FSharpResult$2(0, ["registrerte havn"]);
        case 13:
            return new FSharpResult$2(0, ["hovedsambands id"]);
        case 14:
            return new FSharpResult$2(0, ["reservert sambandsid"]);
        case 15:
            return new FSharpResult$2(0, ["reservesambandsid"]);
        case 16:
            return new FSharpResult$2(0, ["teknisk inspektør"]);
        case 17:
            return new FSharpResult$2(0, ["hovedfremdriftseffekt"]);
        case 18:
            return new FSharpResult$2(0, ["sekundærfremdriftseffekt"]);
        case 19:
            return new FSharpResult$2(0, ["brutto tonnasje"]);
        case 20:
            return new FSharpResult$2(0, ["netto tonnasje"]);
        case 21:
            return new FSharpResult$2(0, ["sikkerhets tonnasje"]);
        case 22:
            return new FSharpResult$2(0, ["dødvekt tonnasje"]);
        case 23:
            return new FSharpResult$2(0, ["største lengde"]);
        case 24:
            return new FSharpResult$2(0, ["største bredde"]);
        case 25:
            return new FSharpResult$2(0, ["høyeste vannlinje"]);
        case 26:
            return new FSharpResult$2(0, ["WaterLineMaxDraft"]);
        case 27:
            return new FSharpResult$2(0, ["framdriftseffekt"]);
        case 28:
            return new FSharpResult$2(0, ["NoXFactorMGO"]);
        case 29:
            return new FSharpResult$2(0, ["NoXFactorLNG"]);
        case 30:
            return new FSharpResult$2(0, ["maksimum gjennomkjøringshøyde"]);
        case 31:
            return new FSharpResult$2(0, ["hengedekk"]);
        case 32:
            return new FSharpResult$2(0, ["underdekk"]);
        case 33:
            return new FSharpResult$2(0, ["CruisingSpeed"]);
        case 34:
            return new FSharpResult$2(0, ["maksimum fart"]);
        case 35:
            return new FSharpResult$2(0, ["maksimum dekklast"]);
        case 36:
            return new FSharpResult$2(0, ["maksimum aksellast"]);
        case 37:
            return new FSharpResult$2(0, ["batterialder"]);
        case 38:
            return new FSharpResult$2(0, ["batterieffekt"]);
        case 39:
            return new FSharpResult$2(0, ["batterileverandør"]);
        case 40:
            return new FSharpResult$2(0, ["batteritype"]);
        case 41:
            return new FSharpResult$2(0, ["batteriladningssystem"]);
        case 42:
            return new FSharpResult$2(0, ["MES type"]);
        case 43:
            return new FSharpResult$2(0, ["Mob Boat type"]);
        case 44:
            return new FSharpResult$2(0, ["motorleverandør"]);
        case 45:
            return new FSharpResult$2(0, ["avdeling"]);
        case 46:
            return new FSharpResult$2(0, ["sambandtype"]);
        case 47:
            return new FSharpResult$2(0, ["el-tavle"]);
        case 48:
            return new FSharpResult$2(0, ["el-tavle leverandør"]);
        case 49:
            return new FSharpResult$2(0, ["integrert automasjonssystem"]);
        case 50:
            return new FSharpResult$2(0, ["MES kapasitet pr flåte"]);
        case 51:
            return new FSharpResult$2(0, ["MES kapasitet total"]);
        case 52:
            return new FSharpResult$2(0, ["antall passasjerer"]);
        case 53:
            return new FSharpResult$2(0, ["antall passasjerseter"]);
        case 54:
            return new FSharpResult$2(0, ["PBE"]);
        case 55:
            return new FSharpResult$2(0, ["PBE + VTE"]);
        case 56:
            return new FSharpResult$2(0, ["VTE"]);
        case 57:
            return new FSharpResult$2(0, ["MVTE"]);
        case 58:
            return new FSharpResult$2(0, ["telefon 1"]);
        case 59:
            return new FSharpResult$2(0, ["telefon 2"]);
        case 60:
            return new FSharpResult$2(0, ["telefon catering"]);
        case 61:
            return new FSharpResult$2(0, ["telefon hemmelig"]);
        case 62:
            return new FSharpResult$2(0, ["e-post"]);
        case 63:
            return new FSharpResult$2(0, ["kantine"]);
        case 64:
            return new FSharpResult$2(0, ["betalingsautomat"]);
        case 65:
            return new FSharpResult$2(0, ["passasjersalonger over vannlinjen"]);
        case 66:
            return new FSharpResult$2(0, ["antall lugarer"]);
        case 67:
            return new FSharpResult$2(0, ["handikaptoalett"]);
        case 68:
            return new FSharpResult$2(0, ["heis"]);
        case 69:
            return new FSharpResult$2(0, ["trappeheis"]);
        case 70:
            return new FSharpResult$2(0, ["krav ECDIS"]);
        case 71:
            return new FSharpResult$2(0, ["krav GMDSS"]);
        case 72:
            return new FSharpResult$2(0, ["krav HMOB"]);
        case 73:
            return new FSharpResult$2(0, ["krav utslipp"]);
        case 74:
            return new FSharpResult$2(0, ["WIFI"]);
        case 75:
            return new FSharpResult$2(0, ["lekerom"]);
        case 76:
            return new FSharpResult$2(0, ["vannlinje til recess"]);
        case 77:
            return new FSharpResult$2(0, ["ampere landstrøm"]);
        case 78:
            return new FSharpResult$2(0, ["volt landstrøm"]);
        case 79:
            return new FSharpResult$2(0, ["primær fremdrift"]);
        case 80:
            return new FSharpResult$2(0, ["sekundær fremdrift"]);
        case 81:
            return new FSharpResult$2(0, ["kapasitet europaller"]);
        case 82:
            return new FSharpResult$2(0, ["sykelugar"]);
        case 83:
            return new FSharpResult$2(0, ["stikktype landstrøm"]);
        case 84:
            return new FSharpResult$2(0, ["sertifikatkrav kaptein"]);
        case 85:
            return new FSharpResult$2(0, ["sertifikatkrav maskinsjef"]);
        case 86:
            return new FSharpResult$2(0, ["sertifikatkrav overstyrmann"]);
        case 87:
            return new FSharpResult$2(0, ["sertifikatkrav 1. maskinist"]);
        case 88:
            return new FSharpResult$2(0, ["sertifikatkrav førstestyrmann"]);
        case 89:
            return new FSharpResult$2(0, ["sertifikatkraf 2. maskinist"]);
        case 90:
            return new FSharpResult$2(0, ["fartsområde"]);
        case 91:
            return new FSharpResult$2(0, ["diverse tekst"]);
        case 92:
            return new FSharpResult$2(0, ["telefon maskin"]);
        default:
            return new FSharpResult$2(1, [`Vessel field id ${column} is not supported or does not exist`]);
    }
}

export function Vessel_Audit_Prop_handleExistenceEvent_Z524259A4(column) {
    switch (column) {
        case 10001:
            return "Opprettet";
        case 10002:
            return "Slettet";
        case 10003:
            return "Aktivitet slettet";
        default:
            return undefined;
    }
}

export const Vessel_mainRouteColumnId = Vessel_Audit_Prop_ToColumnId_Z1D040058(new Vessel_Audit_Prop(12, []));

export const Vessel_reservedRouteColumnId = Vessel_Audit_Prop_ToColumnId_Z1D040058(new Vessel_Audit_Prop(13, []));

export const Vessel_backupRouteColumnId = Vessel_Audit_Prop_ToColumnId_Z1D040058(new Vessel_Audit_Prop(14, []));

export class Route_RouteState extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["InUse", "Archived", "OutThroughSeason"];
    }
    toString() {
        const this$ = this;
        return (this$.tag === 1) ? "Arkivert" : ((this$.tag === 2) ? "Ute for sesongen" : "I bruk");
    }
}

export function Route_RouteState_$reflection() {
    return union_type("Shared.Route.RouteState", [], Route_RouteState, () => [[], [], []]);
}

export function Route_RouteState_FromInt_Z524259A4(x) {
    switch (x) {
        case 2:
            return new Route_RouteState(1, []);
        case 3:
            return new Route_RouteState(2, []);
        default:
            return new Route_RouteState(0, []);
    }
}

export function Route_RouteState_AllStatuses() {
    return [new Route_RouteState(0, []), new Route_RouteState(1, []), new Route_RouteState(2, [])];
}

/**
 * Tries to get route state from identifier int, returns None if identifier is invalid.
 */
export function Route_RouteState_TryFromIdentifier_Z524259A4(i) {
    switch (i) {
        case 1:
            return new Route_RouteState(0, []);
        case 2:
            return new Route_RouteState(1, []);
        case 3:
            return new Route_RouteState(2, []);
        default:
            return undefined;
    }
}

/**
 * Get vesselstate from identifier int, defaults to Operation if identifier is invalid.
 */
export function Route_RouteState_get_FromIdentifier() {
    return (arg) => defaultArg(Route_RouteState_TryFromIdentifier_Z524259A4(arg), new Route_RouteState(0, []));
}

export function Route_RouteState__get_Identifier(this$) {
    switch (this$.tag) {
        case 1:
            return 2;
        case 2:
            return 3;
        default:
            return 1;
    }
}

export class Route_AuditProp extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["TypeId", "Name", "Number", "PublicNumber", "Address", "PostalNumber", "PostalLocation", "ProductionDemand", "Status", "ActivityType", "TenderStart", "TenderEnd", "TravelMethod", "TravelMethodUrl", "FreeText", "DeliveryBunkers", "Dormitory", "Department", "ClientId"];
    }
}

export function Route_AuditProp_$reflection() {
    return union_type("Shared.Route.AuditProp", [], Route_AuditProp, () => [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []]);
}

export function Route_AuditProp_FromString_Z721C83C5(str) {
    switch (str) {
        case "TypeId":
            return new FSharpResult$2(0, [new Route_AuditProp(0, [])]);
        case "Name":
            return new FSharpResult$2(0, [new Route_AuditProp(1, [])]);
        case "Number":
            return new FSharpResult$2(0, [new Route_AuditProp(2, [])]);
        case "PublicNumber":
            return new FSharpResult$2(0, [new Route_AuditProp(3, [])]);
        case "Address":
            return new FSharpResult$2(0, [new Route_AuditProp(4, [])]);
        case "PostalNumber":
            return new FSharpResult$2(0, [new Route_AuditProp(5, [])]);
        case "PostalLocation":
            return new FSharpResult$2(0, [new Route_AuditProp(6, [])]);
        case "ProductionDemand":
            return new FSharpResult$2(0, [new Route_AuditProp(7, [])]);
        case "Status":
            return new FSharpResult$2(0, [new Route_AuditProp(8, [])]);
        case "ActivityType":
            return new FSharpResult$2(0, [new Route_AuditProp(9, [])]);
        case "TenderStart":
            return new FSharpResult$2(0, [new Route_AuditProp(10, [])]);
        case "TenderEnd":
            return new FSharpResult$2(0, [new Route_AuditProp(11, [])]);
        case "TravelMethod":
            return new FSharpResult$2(0, [new Route_AuditProp(12, [])]);
        case "TravelMethodUrl":
            return new FSharpResult$2(0, [new Route_AuditProp(13, [])]);
        case "FreeText":
            return new FSharpResult$2(0, [new Route_AuditProp(14, [])]);
        case "DeliveryBunkers":
            return new FSharpResult$2(0, [new Route_AuditProp(15, [])]);
        case "Dormitory":
            return new FSharpResult$2(0, [new Route_AuditProp(16, [])]);
        case "Department":
            return new FSharpResult$2(0, [new Route_AuditProp(17, [])]);
        case "ClientId":
            return new FSharpResult$2(0, [new Route_AuditProp(18, [])]);
        default:
            return new FSharpResult$2(1, [`Route property ${str} does not exist`]);
    }
}

export function Route_AuditProp_ToColumnId_Z4689315B(prop) {
    switch (prop.tag) {
        case 1:
            return 3;
        case 2:
            return 4;
        case 4:
            return 5;
        case 5:
            return 6;
        case 6:
            return 7;
        case 7:
            return 8;
        case 8:
            return 9;
        case 9:
            return 11;
        case 10:
            return 12;
        case 11:
            return 13;
        case 12:
            return 14;
        case 13:
            return 15;
        case 14:
            return 16;
        case 15:
            return 17;
        case 16:
            return 18;
        case 17:
            return 19;
        case 18:
            return 20;
        case 3:
            return 21;
        default:
            return 2;
    }
}

export function Route_AuditProp_FromColumnId_Z524259A4(prop) {
    switch (prop) {
        case 2:
            return new FSharpResult$2(0, ["type"]);
        case 3:
            return new FSharpResult$2(0, ["navn"]);
        case 4:
            return new FSharpResult$2(0, ["nummer"]);
        case 5:
            return new FSharpResult$2(0, ["addresse"]);
        case 6:
            return new FSharpResult$2(0, ["postnummer"]);
        case 7:
            return new FSharpResult$2(0, ["poststed"]);
        case 8:
            return new FSharpResult$2(0, ["produksjonskrav"]);
        case 9:
            return new FSharpResult$2(0, ["status"]);
        case 11:
            return new FSharpResult$2(0, ["aktivitetstype"]);
        case 12:
            return new FSharpResult$2(0, ["anbud startsdato"]);
        case 13:
            return new FSharpResult$2(0, ["anbud sluttdato"]);
        case 14:
            return new FSharpResult$2(0, ["reisemåte"]);
        case 15:
            return new FSharpResult$2(0, ["reisemåtens URL"]);
        case 16:
            return new FSharpResult$2(0, ["diverse tekst"]);
        case 17:
            return new FSharpResult$2(0, ["leveringssted bunkers"]);
        case 18:
            return new FSharpResult$2(0, ["forlegning/hybelhus"]);
        case 19:
            return new FSharpResult$2(0, ["avdeling"]);
        case 20:
            return new FSharpResult$2(0, ["ID hos oppdragsgiver"]);
        case 21:
            return new FSharpResult$2(0, ["offentlig sambandsnummer"]);
        default:
            return new FSharpResult$2(1, [`This column id does not exist: ${prop}`]);
    }
}

export function Route_AuditProp_handleExistenceEvent_Z524259A4(column) {
    switch (column) {
        case -3:
            return "Aktivitet slettet";
        case -2:
            return "Slettet";
        case -1:
            return "Opprettet";
        default:
            return undefined;
    }
}

export class Activity_ActivityType extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Production", "OtherActivity", "Event", "Shipyard", "Standby"];
    }
    toString() {
        const this$ = this;
        return (this$.tag === 1) ? "Annen aktivitet" : ((this$.tag === 2) ? "Hendelse" : ((this$.tag === 3) ? "Verksted" : ((this$.tag === 4) ? "Opplag" : "Produksjon")));
    }
}

export function Activity_ActivityType_$reflection() {
    return union_type("Shared.Activity.ActivityType", [], Activity_ActivityType, () => [[], [], [], [], []]);
}

export function Activity_ActivityType_AllActivityTypes() {
    return [new Activity_ActivityType(0, []), new Activity_ActivityType(2, []), new Activity_ActivityType(3, []), new Activity_ActivityType(4, []), new Activity_ActivityType(1, [])];
}

export function Activity_ActivityType_FromId_Z524259A4(x) {
    switch (x) {
        case 2:
            return new Activity_ActivityType(1, []);
        case 3:
            return new Activity_ActivityType(2, []);
        case 4:
            return new Activity_ActivityType(3, []);
        case 5:
            return new Activity_ActivityType(4, []);
        default:
            return new Activity_ActivityType(0, []);
    }
}

export function Activity_ActivityType_TryFromId_Z524259A4(x) {
    switch (x) {
        case 1:
            return new Activity_ActivityType(0, []);
        case 2:
            return new Activity_ActivityType(1, []);
        case 3:
            return new Activity_ActivityType(2, []);
        case 4:
            return new Activity_ActivityType(3, []);
        case 5:
            return new Activity_ActivityType(4, []);
        default:
            return undefined;
    }
}

export function Activity_ActivityType__get_Id(this$) {
    switch (this$.tag) {
        case 1:
            return 2;
        case 2:
            return 3;
        case 3:
            return 4;
        case 4:
            return 5;
        default:
            return 1;
    }
}

export function Activity_ActivityType__ColorCode(this$) {
    switch (this$.tag) {
        case 2:
            return "rgb(255, 122, 117)";
        case 3:
            return "rgb(182, 184, 186)";
        case 4:
            return "rgb(207, 232, 255)";
        case 1:
            return "rgb(242, 234, 165)";
        default:
            return "rgb(171, 245, 197)";
    }
}

export function Activity_ActivityType__SingleDayClassName(this$) {
    switch (this$.tag) {
        case 2:
            return "vis-single-day-event";
        case 3:
            return "vis-single-day-shipyard";
        case 4:
            return "vis-single-day-standby";
        case 1:
            return "vis-single-day-other";
        default:
            return "vis-single-day-production";
    }
}

export class Activity_AuditProp extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["VesselId", "RouteId", "FromDate", "ToDate", "InfoText", "VesselAvailable", "Confirmed", "ActivityType\'"];
    }
}

export function Activity_AuditProp_$reflection() {
    return union_type("Shared.Activity.AuditProp", [], Activity_AuditProp, () => [[], [], [], [], [], [], [], []]);
}

export function Activity_AuditProp_get_FromString() {
    return (_arg) => ((_arg === "VesselId") ? (new FSharpResult$2(0, [new Activity_AuditProp(0, [])])) : ((_arg === "RouteId") ? (new FSharpResult$2(0, [new Activity_AuditProp(1, [])])) : ((_arg === "FromDate") ? (new FSharpResult$2(0, [new Activity_AuditProp(2, [])])) : ((_arg === "ToDate") ? (new FSharpResult$2(0, [new Activity_AuditProp(3, [])])) : ((_arg === "InfoText") ? (new FSharpResult$2(0, [new Activity_AuditProp(4, [])])) : ((_arg === "VesselAvailable") ? (new FSharpResult$2(0, [new Activity_AuditProp(5, [])])) : ((_arg === "Confirmed") ? (new FSharpResult$2(0, [new Activity_AuditProp(6, [])])) : ((_arg === "ActivityType") ? (new FSharpResult$2(0, [new Activity_AuditProp(7, [])])) : (new FSharpResult$2(1, [`Property ${_arg} does not exist in the Activity entity`]))))))))));
}

export function Activity_AuditProp_get_ToColumnId() {
    return (_arg) => ((_arg.tag === 1) ? 2 : ((_arg.tag === 2) ? 3 : ((_arg.tag === 3) ? 4 : ((_arg.tag === 4) ? 5 : ((_arg.tag === 5) ? 6 : ((_arg.tag === 6) ? 7 : ((_arg.tag === 7) ? 8 : 1)))))));
}

export function Activity_AuditProp_get_FromColumnId() {
    return (_arg) => ((_arg === 1) ? (new FSharpResult$2(0, ["fartøys id"])) : ((_arg === 2) ? (new FSharpResult$2(0, ["sambands id"])) : ((_arg === 3) ? (new FSharpResult$2(0, ["fra dato"])) : ((_arg === 4) ? (new FSharpResult$2(0, ["til dato"])) : ((_arg === 5) ? (new FSharpResult$2(0, ["beskrivelse"])) : ((_arg === 6) ? (new FSharpResult$2(0, ["fartøy tilgjengelig"])) : ((_arg === 7) ? (new FSharpResult$2(0, ["bekreftet"])) : ((_arg === 8) ? (new FSharpResult$2(0, ["aktivitetstype"])) : (new FSharpResult$2(1, [`Activity: This column id does not exist ${_arg}`]))))))))));
}

export function Activity_AuditProp_handleExistenceEvent_Z524259A4(column) {
    switch (column) {
        case 20001:
            return "Opprettet";
        case 20002:
            return "Slettet";
        default:
            return undefined;
    }
}

export class HistoricState extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Planned", "Active", "History"];
    }
    toString() {
        const this$ = this;
        return (this$.tag === 1) ? "Aktiv" : ((this$.tag === 2) ? "Historisk" : "Planlagt");
    }
}

export function HistoricState_$reflection() {
    return union_type("Shared.HistoricState", [], HistoricState, () => [[], [], []]);
}

export function HistoricState_get_AllTypes() {
    return [new HistoricState(0, []), new HistoricState(1, []), new HistoricState(2, [])];
}

/**
 * Calculates historic state of an activity based on its start and end dates, and todays date.
 */
export function HistoricState_CalculateFromDates(startDate, ending) {
    const today = today_1();
    if (ending != null) {
        const endDate = ending;
        if ((compare(today, endDate) <= 0) && (compare(today, startDate) >= 0)) {
            return new HistoricState(1, []);
        }
        else if (compare(today, endDate) > 0) {
            return new HistoricState(2, []);
        }
        else {
            return new HistoricState(0, []);
        }
    }
    else if (compare(today, startDate) >= 0) {
        return new HistoricState(1, []);
    }
    else {
        return new HistoricState(0, []);
    }
}

export function HistoricState__get_ColorCode(this$) {
    switch (this$.tag) {
        case 1:
            return "#228b22";
        case 2:
            return "#8b4513";
        default:
            return "#ffd700";
    }
}

export class PropulsionType extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Diesel", "Electric", "Hydrogen", "Gas", "NoPropulsion"];
    }
    toString() {
        const this$ = this;
        return (this$.tag === 1) ? "Elektrisitet" : ((this$.tag === 2) ? "Hydrogen" : ((this$.tag === 3) ? "Gass" : ((this$.tag === 4) ? "Ukjent" : "Diesel")));
    }
}

export function PropulsionType_$reflection() {
    return union_type("Shared.PropulsionType", [], PropulsionType, () => [[], [], [], [], []]);
}

export function PropulsionType_get_Default() {
    return new PropulsionType(4, []);
}

export function PropulsionType_FromInt_Z524259A4(x) {
    switch (x) {
        case 1:
            return new PropulsionType(0, []);
        case 2:
            return new PropulsionType(1, []);
        case 3:
            return new PropulsionType(2, []);
        case 4:
            return new PropulsionType(3, []);
        default:
            return new PropulsionType(4, []);
    }
}

export function PropulsionType__ToInt(this$) {
    switch (this$.tag) {
        case 1:
            return 2;
        case 2:
            return 3;
        case 3:
            return 4;
        case 4:
            return -1;
        default:
            return 1;
    }
}

export const allPropulsionTypes = [new PropulsionType(4, []), new PropulsionType(0, []), new PropulsionType(1, []), new PropulsionType(2, []), new PropulsionType(3, [])];

//# sourceMappingURL=Shared.js.map
